import { AUDIO_DURATION } from '@/app/constants';
import type { Text2AudioFormParams } from '@/app/stores/slices/task-form';
import type { TaskInputPrompts, TaskParams } from '@/app/types';
import { getText2AudioMaxValidSegmentEndTime } from '@/app/utils';

export const convertText2Audio = (formParams: Text2AudioFormParams): TaskParams => {
  const prompts = convertSegments(formParams.segments);
  const settings = normalizeText2AudioSettings(formParams);
  return {
    input: {
      prompts,
      enhance: true,
    },
    type: 'text2audio',
    settings,
  };
};

/**
 * 在提交前获取所有的音频段最大值设置成总时长
 */
const normalizeText2AudioSettings = (
  formParams: Text2AudioFormParams,
): NonNullable<Text2AudioFormParams['settings']> => {
  const originalSettings = formParams.settings ?? {};
  const originalDuration = originalSettings.duration ?? AUDIO_DURATION;

  // 只有一段prompt但是没有时间戳的情况
  if (
    formParams.segments?.length === 1 &&
    formParams.segments[0].startTime === 0 &&
    formParams.segments[0].endTime === 0
  ) {
    return originalSettings;
  }

  const maxEndTime = getText2AudioMaxValidSegmentEndTime(formParams.segments);

  if (maxEndTime < originalDuration) {
    return {
      ...originalSettings,
      duration: maxEndTime,
    };
  }

  return originalSettings;
};

/**
 * 将文生音频的 segments 转换为提交任务接口所需格式
 *
 * @param segments 文生音频的 segments
 * @returns 提交任务接口所需格式
 */
const convertSegments = (segments: Text2AudioFormParams['segments']): TaskInputPrompts[] => {
  return (
    segments?.map(
      (segment) =>
        ({
          type: 'text',
          content: segment.text,
          timing_text:
            segment.startTime === 0 && segment.endTime === 0
              ? undefined
              : {
                  from: segment.startTime,
                  to: segment.endTime,
                },
        }) as TaskInputPrompts,
    ) || []
  );
};
